module.exports = __webpack_public_path__ + "img/trash.2d6180a2.svg";